import { TZDate } from '@date-fns/tz';
import { format } from 'date-fns';

import { SCHEDULED_DELIVERY_DATE_FORMAT, SCHEDULED_DELIVERY_DATE_TIME_ZONE } from '../constants';

export const formatOrderPromisedShipDate = (promisedShipDate: string) => {
    const promisedShipDateTz = new TZDate(promisedShipDate, SCHEDULED_DELIVERY_DATE_TIME_ZONE);

    return format(promisedShipDateTz, SCHEDULED_DELIVERY_DATE_FORMAT);
};
